import React, { Component } from "react";
import CollapseCommand from "../Commands/CollapseCommand/CollapseCommand";
import ReduceCommand from "../Commands/ReduceCommand/ReduceCommand";
import "./DropDownList.css";

class DropDownList extends Component {
  state = {
    currentData: [
      {
        id: 0,
        wording: "Approuver",
      },
      {
        id: 1,
        wording: "Refuser",
      },
    ],
    currentValue: "Decision",
    isExpandable: false,
  };

  handleClickItem = (e, item) => {
    this.setState({
      currentValue: item.wording,
      isExpandable: false,
    });
  };

  handleClickCommand = (e) => {
    this.setState({
      isExpandable: !this.state.isExpandable,
    });
  };

  render() {
    return (
      <div>
        <div className="commandRow">
          <div className="commandLeftCol">
            <span className="dropDownList">{this.state.currentValue}</span>
          </div>
          <div
            className="commandRightCol"
            onClick={(e) => this.handleClickCommand(e)}
          >
            <CollapseCommand
              isShow={!this.state.isExpandable}
              isStandard={true}
            />
            <ReduceCommand isShow={this.state.isExpandable} isStandard={true} />
          </div>
        </div>

        <div
          className="resultatRow"
          style={{
            visibility: this.state.isExpandable ? "visible" : "collapse",
          }}
        >
          <ul className="ulautocomplete">
            {this.state.currentData.map((item) => (
              <li
                className="liautocomplete"
                key={item.id}
                onClick={(e) => this.handleClickItem(e, item)}
              >
                {item.wording}
              </li>
            ))}
          </ul>
        </div>
      </div>
    );
  }
}

export default DropDownList;
